import styled from "styled-components";

import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: ${theme.font.poppins};
  overflow-y: auto;
`;

export const Title = styled.h1`
  color: ${theme.colors.blue100};
  font-size: ${theme.font.sizes.large};
  font-weight: ${theme.font.xbold};
  max-width: 800px;
  text-align: center;

  hr {
    margin: 20px auto;
    color: ${theme.colors.blue400};
    border: 2px solid ${theme.colors.blue400};
    max-width: 53px;
  }

  @media screen and (min-width: 1400px) {
     font-size: ${theme.font.sizes.xlarge};
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 90%;
  gap: 0.5rem;
  margin: 0 auto;

  @media screen and (min-width: 768px) {
    width: 85%;
  }

  @media screen and (min-width: 992px) {
    width: 70%;
  }
`;

export const NewUsersCard = styled.div`
  padding: 0.5rem 1rem;
  border-radius: ${theme.border.xradius};
  background: linear-gradient(180deg, #155a77 0%, #27aae1 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  flex-direction: column;
  gap:1rem;
  margin-bottom: 20px;

  p {
    margin: 0;
    margin-left: 20px;

    font-size: ${theme.font.sizes.medium};
    font-weight: ${theme.font.normal};
    color: ${theme.colors.white};

    span {
      font-weight: ${theme.font.xbold};
    }
  }

  @media screen and (min-width: 768px) {
    aspect-ratio: 4 / 1;
    svg {
      position: absolute;
      left: 40px;
      bottom: 0;
    }
  }

  @media screen and (min-width: 1200px) {
    aspect-ratio: 6.5 / 1;
    svg {
      width: 110px;
      height: 110px;
    }
  }

  @media screen and (min-width: 1400px) {
    aspect-ratio: 6.5 / 1;
    svg {
      width: 130px;
      height: 130px;
    }
  }
`;

export const ContainerCards = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  justify-content: center;
  gap: 2rem;
  margin-top: 40px;

  @media screen and (min-width: 768px) {
    margin-top: 0;
    grid-template-columns: 1fr 1fr;
    place-items: center;
  }
`;